import { Button, Stack } from '@mui/material'
import { FC } from 'react'
import { INSIGHT_PERIOD_OPTIONS, InsightPeriod } from './periodPresets'

type Props = {
  value: InsightPeriod
  onChange: (period: InsightPeriod) => void
  disabled?: boolean
}

export const InsightPeriodSelector: FC<Props> = ({ value, onChange, disabled }) => {
  return (
    <Stack direction="row" flexWrap="wrap" gap={1}>
      {INSIGHT_PERIOD_OPTIONS.map((option) => (
        <Button
          key={option.value}
          size="small"
          variant={value === option.value ? 'contained' : 'outlined'}
          onClick={() => onChange(option.value)}
          disabled={disabled}
        >
          {option.label}
        </Button>
      ))}
    </Stack>
  )
}
